import { getSizeMixin } from './size.js'

export default getSizeMixin({
  xs: 30,
  sm: 35,
  md: 40,
  lg: 50,
  xl: 60
})
